export default __webpack_public_path__ + "static/media/A0004.117e29d9.png";